declare const __FORCE_DEV_FEATURES__: boolean;

const env = import.meta.env;
const isDevelopment = env.MODE === 'development' || __FORCE_DEV_FEATURES__;

export const config = {
  ...env,
  baseUrl: isDevelopment ? env.VITE_BASE_URL : env.VITE_PROD_BASE_URL,
  IS_DEVELOPMENT: isDevelopment,
  marketingBaseUrl: env.VITE_MARKETING_BASE_URL,

  // Cognito
  cognito: {
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    clientId: env.VITE_COGNITO_CLIENT_ID,
    endpoint: env.VITE_COGNITO_ENDPOINT,
  },

  social: {
    googleClientId: env.VITE_GOOGLE_CLIENT_ID || '',
    appleServicesId: env.VITE_APPLE_SERVICES_ID || '',
    appleReturnUrl: env.VITE_APPLE_RETURN_URL || '',
  },

  sui: {
    network: (env.VITE_SUI_NETWORK || 'mainnet') as 'mainnet' | 'testnet' | 'devnet',
  },
  privy: {
    appId: env.VITE_PRIVY_APP_ID,
    clientId: env.VITE_PRIVY_CLIENT_ID,
  },
  posthog: {
    apiKey: env.VITE_PUBLIC_POSTHOG_KEY,
    apiHost: env.VITE_PUBLIC_POSTHOG_HOST,
  },
};
